import styled from "@emotion/styled";
import React from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';
import TranslateTransition from "../animations/TranslateTransition";

const TableRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: ${ props =>
    props.gridTemplate
        ? props.gridTemplate
        :`repeat(${props.columnCount}, 150px)`
    };
    margin-bottom: 24px;
    grid-column-start: 1;
    grid-column-end: 5;
    align-items: center;
`;

export const TableCell = styled.span``;

const CustomerRowHeading = styled.h3`
    font-size: var(--font-m);
    color: var(--font-secondary);
    font-weight: 300;
    text-align: center;
    width: fit-content;
    margin: 15px;
`;

export default function SidePanelTableRowComponent(props) {
    const {columnHeaders, rowData, isSelected, onCheckBoxSelected, hasCheckBox, gridTemplate} = props;
    return (
        <TranslateTransition>
            <TableRow
                key={"table-row"}
                hasIndent={!hasCheckBox}
                hasCheckBox={hasCheckBox}
                columnCount={Object.keys(rowData).length}
                gridTemplate={gridTemplate}
            >
                {
                    hasCheckBox && <Checkbox
                        value={rowData.id}
                        checked={isSelected}
                        onChange={e => onCheckBoxSelected(e, rowData)}
                        color="primary"
                    />
                }
                {
                    columnHeaders.map((column, index) => {
                        return React.cloneElement(rowData[column.key] || <div/>, {key: index})
                    })
                }
            </TableRow>
        </TranslateTransition>
    )
}

SidePanelTableRowComponent.propTypes = {
    columnHeaders: PropTypes.array,
    rowData: PropTypes.object,
    isSelected: PropTypes.bool,
    hasCheckBox: PropTypes.bool,
    onCheckBoxSelected: PropTypes.func
};
